var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var PosAngleData = require("../abstract/posAngleData.js");

var FootprintLayers = require("./footprintLayers.js");
var MaterialLayerTypes = require("./../materialTypes.js");

var PadToMesh = require("./../threejsExport/padToMesh.js");

var PadData = function (pos, angle, name, padstack, onTopLayer) {
    var self = this;

    this.makeObservableTreeNode();

    this.addPosAngle(pos, angle);
    this.name = this.value("name", true);
    this.padstack = this.value("padstack", true);
    this.onTopLayer = this.value("onTopLayer", true);

    this.addPadstackInterface();
    this.addGeometryShadows();

    PadToMesh.call(this);

    if(name != undefined) this.name(name);
    if(padstack != undefined) this.padstack(padstack);
    if(onTopLayer != undefined) this.onTopLayer(onTopLayer);
};
lib_core.mixin(PadData, PosAngleData);
lib_core.mixin(PadData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(PadData, "PadData");

module.exports = PadData;

PadData.prototype.addGeometryShadows = function() {
    var self = this;

    this.geometry = this.cachedFunction("geometry",
        this._getGeometry,
        [[this, this.onBubble]]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [[this, this.onBubble]]
    );

    this.boundingBox = this.cachedFunction("boundingBox", function () {
            return this.geometry().getBB();
        },
        [this.geometry]
    );

    this.outlineGeometry = this.segmentedGeometry;
};

PadData.prototype._getGeometry = function () {
    return this.onTopLayer() ? this.getTopCopper().geometry() : this.getBottomCopper().geometry();
};

PadData.prototype._getSegmentedGeometry = function (precision, layerIndex, layerType) {
    var poly;
    if(!layerIndex) layerIndex = this.onTopLayer() ? FootprintLayers.TOP : FootprintLayers.BOTTOM;
    if(!layerType) layerType = MaterialLayerTypes.COPPER;
    switch (layerType) {
        case MaterialLayerTypes.COPPER:
            switch (layerIndex) {
                case FootprintLayers.TOP:
                    poly = this.getTopCopper().segmentedGeometry(precision);
                    break;
                case FootprintLayers.INNER:
                    poly = this.getInnerCopper().segmentedGeometry(precision);
                    break;
                case FootprintLayers.BOTTOM:
                    poly = this.getBottomCopper().segmentedGeometry(precision);
                    break;
            }
            break;
        case MaterialLayerTypes.SOLDERMASK:
            switch (layerIndex) {
                case FootprintLayers.TOP:
                    poly = this.getTopSolderMask().segmentedGeometry(precision);
                    break;
                case FootprintLayers.BOTTOM:
                    poly = this.getBottomSolderMask().segmentedGeometry(precision);
                    break;
            }
            break;
        case MaterialLayerTypes.SOLDERPASTE:
            switch (layerIndex) {
                case FootprintLayers.TOP:
                    poly = this.getTopSolderPaste().segmentedGeometry(precision);
                    break;
                case FootprintLayers.BOTTOM:
                    poly = this.getBottomSolderPaste().segmentedGeometry(precision);
                    break;
            }
            break;
    }
    return poly;
};

PadData.prototype.getDrillSegmentedGeometry = function (precision) {
    if(this.getHole()) {
        return this.getHole().segmentedGeometry(precision);
    } else {
        return null;
    }
};

PadData.prototype.getBottomSegmentedGeometry = function (precision) {
    if(this.getBottomCopper()) {
        return this.getBottomCopper().segmentedGeometry(precision);
    } else {
        return null;
    }
};

PadData.prototype.addPadstackInterface = function () {
    this.getTopCopper = this.cachedFunction("getTopCopper",
        function () {
            var shape;
            if(this.onTopLayer()) {
                shape = this.padstack().topCopper ? this.padstack().topCopper() : null;
            } else {
                shape = this.padstack().bottomCopper ? this.padstack().bottomCopper() : null;
            }
            if(shape) {
                shape = shape.clone();
                shape.move(this.pos());
                shape.rotate(this.angle(), this.pos());
                return shape;
            }
        },
        [this.pos, this.angle, this.onTopLayer, [this.padstack, this.padstack.onBubble]]
    );

    this.getInnerCopper = this.cachedFunction("getInnerCopper",
        function () {
            var shape = this.padstack().innerCopper ? this.padstack().innerCopper() : null;
            if(shape) {
                shape = shape.clone();
                shape.move(this.pos());
                shape.rotate(this.angle(), this.pos());
                return shape;
            }
        },
        [this.pos, this.angle, this.onTopLayer, [this.padstack, this.padstack.onBubble]]
    );

    this.getBottomCopper = this.cachedFunction("getBottomCopper",
        function () {
            var shape;
            if(this.onTopLayer()) {
                shape = this.padstack().bottomCopper ? this.padstack().bottomCopper() : null;
            } else {
                shape = this.padstack().topCopper ? this.padstack().topCopper() : null;
            }
            if(shape) {
                shape = shape.clone();
                shape.move(this.pos());
                shape.rotate(this.angle(), this.pos());
                return shape;
            }
        },
        [this.pos, this.angle, this.onTopLayer, [this.padstack, this.padstack.onBubble]]
    );

    this.getHole = this.cachedFunction("getHole",
        function () {
            var shape;
                shape = this.padstack().hole ? this.padstack().hole() : null;
            if(shape) {
                shape = shape.clone();
                shape.move(this.pos());
                shape.rotate(this.angle(), this.pos());
                return shape;
            }
        },
        [this.pos, this.angle, this.onTopLayer, [this.padstack, this.padstack.onBubble]]
    );

    this.getTopSolderMask = this.cachedFunction("getTopSolderMask",
        function () {
            var shape;
            if(this.onTopLayer()) {
                shape = this.padstack().topSolderMask ? this.padstack().topSolderMask() : null;
            } else {
                shape = this.padstack().bottomSolderMask ? this.padstack().bottomSolderMask() : null;
            }
            if(shape) {
                shape = shape.clone();
                shape.move(this.pos());
                shape.rotate(this.angle(), this.pos());
                return shape;
            }
        },
        [this.pos, this.angle, this.onTopLayer, [this.padstack, this.padstack.onBubble]]
    );

    this.getBottomSolderMask = this.cachedFunction("getBottomSolderMask",
        function () {
            var shape;
            if(this.onTopLayer()) {
                shape = this.padstack().bottomSolderMask ? this.padstack().bottomSolderMask() : null;
            } else {
                shape = this.padstack().topSolderMask ? this.padstack().topSolderMask() : null;
            }
            if(shape) {
                shape = shape.clone();
                shape.move(this.pos());
                shape.rotate(this.angle(), this.pos());
                return shape;
            }
        },
        [this.pos, this.angle, this.onTopLayer, [this.padstack, this.padstack.onBubble]]
    );

    this.getTopSolderPaste = this.cachedFunction("getTopSolderPaste",
        function () {
            var self = this;
            var shape;

            if(this.onTopLayer()) {
                shape = this.padstack().topSolderPaste ? this.padstack().topSolderPaste() : null;
            }

            if(shape) {
                if(!Array.isArray(shape)) {
                    shape = [].concat(shape);
                }

                shape.forEach(function(s) {
                    s.move(self.pos());
                    s.rotate(self.angle(), self.pos());
                });
            }

            return shape;
        },
        [this.pos, this.angle, this.onTopLayer, [this.padstack, this.padstack.onBubble]]
    );

    this.getBottomSolderPaste = this.cachedFunction("getBottomSolderPaste",
        function () {
            var self = this;
            var shape;
            
            if(!this.onTopLayer()) {
                shape = this.padstack().topSolderPaste ? this.padstack().topSolderPaste() : null;
            }

            if(shape) {
                if(!Array.isArray(shape)) {
                    shape = [].concat(shape);
                }

                shape.forEach(function(s) {
                    s.move(self.pos());
                    s.rotate(self.angle(), self.pos());
                });
            }

            return shape;
        },
        [this.pos, this.angle, this.onTopLayer, [this.padstack, this.padstack.onBubble]]
    );

    this.getThermalCutout = this.cachedFunction("getThermalCutout",
        function () {
            var shape = this.padstack().thermalCutout.apply(this, arguments);
            if(shape) {
                shape = shape.translate(this.pos());
                shape = shape.rotate(this.angle(), this.pos());
                return shape;
            }
        },
        [this.pos, this.angle, this.onTopLayer, [this.padstack, this.padstack.onBubble]]
    );
};

